var $ = jQuery.noConflict();




window.onload = (event) =>{

  
 
};
/* Script on ready
------------------------------------------------------------------------------*/
$( document ).ready( function() {
	//do jQuery stuff when DOM is ready
    
    if ($(window).width() < 1023) {

      $('.block-1520914306190').clone().appendTo('.block-1520914258601');

      $(".block-1520914258601 h3").click(function(){
        $(".block-1520914258601 ul").slideToggle( "slow" );
      });

      $(".block-e9fb993a-9b86-4b68-9408-ec218c596670 h3").click(function(){
        $(".block-e9fb993a-9b86-4b68-9408-ec218c596670 ul").slideToggle( "slow" );
      });

      $(".con-banner .gallery__column-container").slick({

        dots: false,
        arrows: true,
        infinite: true,
        autoplay: true,
        speed: 300,
        slidesToShow: 1,
        prevArrow: '<div class="slick-prev"><span class="con-arrow-left" aria-hidden="true"></span></div>',
        nextArrow: '<div class="slick-next"><span class="con-arrow-right" aria-hidden="true"></span></div>'

      });
      
    }

    $('.homepage-collection-list .collection__grid-loop').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 8,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
  
} );
